import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { ServidorAlfresco } from '../../../_models/servidor-alfresco';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NavService } from '../../../_services/_nav.service';
import { ServidorAlfrescoService } from '../../../_services/servidor-alfresco.service';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-servidores-alfresco-editar',
  templateUrl: './servidores-alfresco-editar.component.html',
  styleUrls: ['./servidores-alfresco-editar.component.css'],
})
export class ServidoresAlfrescoEditarComponent implements OnInit {
  carInformacionInicial = true;
  formulario: FormGroup;
  funcionalidad: Funcionalidad = new Funcionalidad();
  submitted = false;
  servidorAlfresco: ServidorAlfresco;
  servidoresAlfresco: ServidorAlfresco[] = [];
  guardando = false;

  constructor(
    private authService: AutenticacionService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private navService: NavService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private servidorAlfrescoService: ServidorAlfrescoService,
    private location: Location
  ) {}

  ngOnInit() {
    this.route.params.subscribe(async (params: Params) => {
      if (params['id']) {
        this.servidorAlfresco = await this.servidorAlfrescoService.obtenerPorId(params['id']).toPromise();
      }
      this.cargaInicial();
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idServidorAlfresco: [this.servidorAlfresco ? this.servidorAlfresco.idServidorAlfresco : null],
      nombre: [this.servidorAlfresco ? this.servidorAlfresco.nombre : null, [Validators.required]],
      ruta: [this.servidorAlfresco ? this.servidorAlfresco.ruta : null, [Validators.required]],
      fechaCreacion: [this.servidorAlfresco ? this.servidorAlfresco.fechaCreacion : null],
      indicadorHabilitado: [
        this.servidorAlfresco ? this.servidorAlfresco.indicadorHabilitado : true,
        [Validators.required],
      ],
    });
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }

  cargaInicial() {
    forkJoin(this.servidorAlfrescoService.listado()).subscribe(([servidoresAlfresco]) => {
      this.servidoresAlfresco = servidoresAlfresco;
      this.cargarFormulario();
    });
  }

  validarRuta() {
    return !!this.servidoresAlfresco.find((x) => (x.ruta).toLowerCase() === (this.f.ruta.value).toLowerCase() && ((this.servidorAlfresco && this.servidorAlfresco.idServidorAlfresco !== x.idServidorAlfresco) || !this.servidorAlfresco));
  }

  validarHabilitado() {
    return !!this.servidoresAlfresco.find((x) => x.indicadorHabilitado && ((this.servidorAlfresco && this.servidorAlfresco.idServidorAlfresco !== x.idServidorAlfresco) || !this.servidorAlfresco));
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      if (this.validarRuta()) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
          detail: this.navService.buscarMensaje( 'SERVIDORALFRESCO.MSG_ERRORRUTA' )
        } );
        return;
      }

      if (!this.f.indicadorHabilitado.value && !this.validarHabilitado()) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
          detail: this.navService.buscarMensaje( 'SERVIDORALFRESCO.MSG_MINIMOUNOHABILITADO' )
        } );
        return;
      }

      if (!this.f.indicadorHabilitado.value && this.validarHabilitado()) {
        this.guardarServidorAlfresco();
        return;
      }

      if (this.validarHabilitado()) {
        this.confirmationService.confirm({
          message: this.navService.buscarMensaje('SERVIDORALFRESCO.MSG_YAEXISTEREGISTROHABILITADO'),
          header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
          icon: 'fa fa-question-circle',
          accept: () => {
            this.guardarServidorAlfresco();
          },
        });
        return;
      } else {
        this.guardarServidorAlfresco();
      }
    }
  }


  async guardarServidorAlfresco () {
    const registro = this.formulario.getRawValue();
    if (registro.idServidorAlfresco) {
      await this.servidorAlfrescoService.actualizar(registro).toPromise();
      this.navService.setMesage(2);
      this.formulario.markAsPristine();
      this.guardando = false;
      this.submitted = false;
      this.location.back();
    } else {
      await this.servidorAlfrescoService.crear(registro).toPromise();
      this.navService.setMesage(2);
      this.formulario.markAsPristine();
      this.guardando = false;
      this.submitted = false;
      this.location.back();
    }
  }

  cancelar(fDirty: boolean): void {
    if (fDirty) {
      this.confirmationService.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
      });
    } else {
      this.location.back();
    }
  }
}
